import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../../forms/commonMeta";

export interface IStatesFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
    id: FormInputMeta;
    stateConfiguration: FormInputMeta;
    stateNum: FormInputMeta;
    stateType: FormInputMeta;

    schema: any;
}

const statesFormMeta = {} as IStatesFormMeta;

statesFormMeta.bankID = {...BankIDInputMeta, label: "ID Banque"};

statesFormMeta.corporateName = {...CorporateNameInputMeta, label: "Nom"};

statesFormMeta.id = {
  name: "id",
  type: "text",
  label: "ID",
  placeholder: "Veuillez entrer l'ID svp...",
  validation: yup.string().required(),
};

statesFormMeta.stateConfiguration = {
  name: "stateConfiguration",
  type: "text",
  label: "Configuration Etat",
  placeholder: "Veuillez entrer la configuration état svp...",
  validation: yup.string().required(),
};

statesFormMeta.stateNum = {
  name: "stateNum",
  type: "text",
  label: "Numéro Etat",
  placeholder: "Veuillez entrer le Numéro état svp...",
  validation: yup.string().required(),
};

statesFormMeta.stateType = {
  name: "stateType",
  type: "select",
  label: "Type Etat",
  placeholder: "Veuillez choisir le Type état svp...",
  validation: yup.string().required(),
};

statesFormMeta.schema = yup.object().shape(getValidationSchema(statesFormMeta));

export default statesFormMeta;